import { render, staticRenderFns } from "./AchievementsVolunteers.vue?vue&type=template&id=6f08945b&"
import script from "./AchievementsVolunteers.vue?vue&type=script&lang=js&"
export * from "./AchievementsVolunteers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports